import useChatActions from '@src/hooks/useChatActions';
import { selectHasCallInActiveChat } from '@src/selectors/calls';
import { activeChatSelector } from '@src/selectors/chats';
import React from 'react';
import { useSelector } from 'react-redux';
import ActionButtons, { ActionButtonsType } from './ActionButtons';

const CloseButton: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const chatActions = useChatActions();
  const activeChat = useSelector(activeChatSelector);
  const activeChatHasCall = useSelector(selectHasCallInActiveChat);

  const isChatActive = activeChat && !!activeChat?.id;
  const isTransfer = activeChat && !!activeChat?.chatXferRequest;
  const disabledButton =
    !isChatActive || isTransfer || activeChatHasCall || disabled;

  const handleCloseActiveChat = () => {
    if (isChatActive) {
      chatActions.closeChat(activeChat.id);
    }
  };

  return (
    <ActionButtons
      type={'close' as ActionButtonsType}
      onClick={handleCloseActiveChat}
      disabled={disabledButton}
    />
  );
};

export default CloseButton;
